'use strict';
import { j as s } from "../../external/react/jsx-runtime.js";
import e from "./form.module.scss.js";
import { FontAwesomeIcon as r } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faSpinnerThird as w, faTriangleExclamation as y } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { forwardRef as F } from "react";
const C = F(
  ({
    placeholder: p = "Enter text here...",
    type: j = "text",
    id: t,
    name: a,
    label: i,
    prefix: c,
    leftIcon: x,
    rightIcon: o,
    isLoading: u,
    error: l,
    helperText: h,
    disabled: d,
    required: f,
    showFeedback: N = !0,
    capitalise: v,
    onChange: m,
    ...g
  }, E) => /* @__PURE__ */ s.jsxs("div", { className: e["field-container"], children: [
    i ? /* @__PURE__ */ s.jsxs("div", { className: e["label-container"], children: [
      /* @__PURE__ */ s.jsx("label", { htmlFor: t || a, children: /* @__PURE__ */ s.jsx("small", { children: i }) }),
      f ? /* @__PURE__ */ s.jsx("span", { className: e.required, children: "*" }) : null
    ] }) : null,
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: e["input-container"],
        "data-disabled": d,
        "data-has-error": !!l,
        children: [
          c ? /* @__PURE__ */ s.jsx("span", { children: c }) : null,
          x ? /* @__PURE__ */ s.jsx(r, { icon: x }) : null,
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ref: E,
              type: j,
              id: t || a,
              name: a,
              placeholder: p,
              disabled: d,
              onChange: (n) => {
                v && (n.target.value = n.target.value.toUpperCase()), m && m(n);
              },
              ...g
            }
          ),
          o ? /* @__PURE__ */ s.jsx(r, { icon: o }) : null,
          u ? /* @__PURE__ */ s.jsx(r, { icon: w, spin: !0 }) : null
        ]
      }
    ),
    N && /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-2 pl-4 text-sm h-5", children: l ? /* @__PURE__ */ s.jsxs("span", { className: "text-red-error space-x-2", children: [
      /* @__PURE__ */ s.jsx(r, { icon: y }),
      /* @__PURE__ */ s.jsx("span", { children: l })
    ] }) : /* @__PURE__ */ s.jsx("span", { className: "text-grey-400", children: h }) })
  ] })
);
export {
  C as default
};
